import bact from '@/sui/data/sheets/edit/bact'
import patient from '@/sui/data/sheets/edit/patient'
import micro from '@/sui/data/sheets/edit/micro'
import multi from '@/sui/data/sheets/edit/multi'
import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import notes from '@/sui/data/sheets/edit/notes/diaInfADI'
import cfg from '@/sui/data/sheets/edit/cfg/diaInfADI'

const titles = [
  {
    text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
    type: 'title',
    start: 'uf'
  },
  {
    text: `FACTEURS DE RISQUE LIÉS AU PATIENT AU MOMENT DE L'INCLUSION`,
    type: 'title',
    start: 'treatedDiab'
  },
  {
    text: 'SUIVI DU PATIENT PENDANT LA PÉRIODE DE SUIVI',
    type: 'title',
    start: 'dialNumber'
  },
  {
    text: 'DEVENIR DU PATIENT',
    type: 'title',
    start: 'exit'
  },
  {
    text: `DONNÉES RELATIVES À L'EXPOSITION AUX CATHÉTERS / FISTULES`,
    type: 'title',
    start: 'catheters'
  },
  {
    text: `BACTÉRIÉMIES NON LIÉES AU SITE D'ACCÈS`,
    start: 'bacteremias',
    type: 'title'
  }
]

const patientFields = {
  v1: [
    patient.sheetNumber.v1,
    patient.ufs.diaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    cfg.firstSubstn,
    cfg.hemodiafiltr,
    cfg.entryDate,
    cfg.treatedDiab,
    cfg.immuno,
    cfg.hygiene,
    cfg.previousInfect,
    cfg.previousBact,
    cfg.toxico,
    cfg.vih,
    cfg.vhc,
    cfg.height,
    cfg.weight,
    cfg.ferritinaemia,
    cfg.saturation,
    cfg.hemoglobin,
    cfg.albumin,
    cfg.creatinine,
    cfg.dialNumber,
    cfg.cardioVascPb,
    cfg.surgery,
    cfg.transfusions,
    cfg.exit,
    cfg.exitReason
  ],

  v2: [
    patient.sheetNumber.v2,
    patient.ufs.diaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    cfg.firstSubstn,
    cfg.hemodiafiltr,
    cfg.entryDate,
    cfg.treatedDiab,
    cfg.immuno,
    cfg.hygiene,
    cfg.previousInfect,
    cfg.previousBact,
    cfg.toxico,
    cfg.vih,
    cfg.vhc,
    cfg.height,
    cfg.weight,
    cfg.ferritinaemia,
    cfg.saturation,
    cfg.hemoglobin,
    cfg.albumin,
    cfg.creatinine,
    cfg.dialNumber,
    cfg.cardioVascPb,
    cfg.surgery,
    cfg.transfusions,
    cfg.exit,
    cfg.exitReason
  ],

  v3: [
    patient.sheetNumber.v2,
    patient.ufs.diaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    cfg.firstSubstn,
    cfg.hemodiafiltr,
    cfg.entryDate,
    cfg.treatedDiab,
    cfg.immuno,
    cfg.hygiene,
    cfg.previousInfect,
    cfg.previousBact,
    cfg.toxico,
    cfg.vih,
    cfg.vhc,
    cfg.height,
    cfg.weight,
    cfg.ferritinaemia,
    cfg.saturation,
    cfg.hemoglobin,
    cfg.albumin,
    cfg.creatinine,
    cfg.dialNumber,
    cfg.cardioVascPb,
    cfg.surgery,
    cfg.transfusions,
    cfg.exit,
    cfg.exitReason,
    multi.covidStatus.exit
  ],

  v4: [
    patient.sheetNumber.v2,
    patient.ufs.diaInfADI,
    patient.unitType.v2.ro,
    patient.birthdate,
    patient.sex,
    cfg.firstSubstn,
    cfg.hemodiafiltr,
    cfg.entryDate,
    cfg.treatedDiab,
    cfg.immuno,
    cfg.hygiene,
    cfg.previousInfect,
    cfg.previousBact,
    cfg.toxico,
    cfg.vih,
    cfg.vhc,
    cfg.height,
    cfg.weight,
    cfg.ferritinaemia,
    cfg.saturation,
    cfg.hemoglobin,
    cfg.albumin,
    cfg.creatinine,
    cfg.dialNumber,
    cfg.cardioVascPb,
    cfg.surgery,
    cfg.transfusions,
    cfg.exit,
    cfg.exitReason,
    multi.covidStatus.exit
  ]
}

const infection = (function () {
  const ignore = {
    v1: tools.not(cfg.select.acc.v1),
    v2: tools.not(cfg.select.acc.v2)
  }

  const common = {
    bactOrigin: tools.select(bact.bactOrigin.v2, cfg.select.inf),
    diagDate: {
      v1: tools.select(bact.diagDate.v1, cfg.select.inf),
      v2: tools.select(bact.diagDate.v2, cfg.select.inf)
    },
    covidStatus: tools.select(multi.covidStatus.std, cfg.select.inf),
    micro: (v) => tools.select(micro[v].noVirus, cfg.select.inf)
  }

  const infFields = {
    v1: [
      cfg.infectionField,
      tools.select(bact.diaOrigin, cfg.select.inf),
      cfg.infectionDate,
      common.micro('v1'),
      cfg.antibio
    ],
    v2: [
      cfg.infectionField,
      common.bactOrigin,
      cfg.infectionDate,
      common.diagDate.v1,
      common.covidStatus,
      cfg.antibio,
      common.micro('v2')
    ],
    v3: [
      cfg.infectionField,
      common.bactOrigin,
      cfg.infectionDate,
      common.diagDate.v1,
      common.covidStatus,
      cfg.antibio,
      common.micro('v4')
    ],
    v4: [
      cfg.infectionField,
      common.bactOrigin,
      cfg.infectionDate,
      common.diagDate.v2,
      common.covidStatus,
      cfg.antibio,
      common.micro('v5')
    ],
    v5: [
      cfg.infectionField,
      common.bactOrigin,
      cfg.infectionDate,
      common.diagDate.v2,
      common.covidStatus,
      cfg.antibio,
      common.micro('v6')
    ]
  }

  function build (list, ign) {
    return {
      type: 'array',
      field: fields.infections,
      config: {
        title: 'INFECTION (LIÉE À CE SITE) N°',
        fields: list
      },

      ignore: ign
    }
  }

  return {
    v1: build(infFields.v1, ignore.v1),
    v2: build(infFields.v2, ignore.v2),
    v3: build(infFields.v3, ignore.v2),
    v4: build(infFields.v4, ignore.v2),
    v5: build(infFields.v5, ignore.v2)
  }
})()

const catheter = (function () {
  const ktFields = {
    v1: [
      cfg.accessSite.v1,
      cfg.catheterFirstUse.v1,
      cfg.uses.v1,
      cfg.incidents.v1,
      cfg.unrelatedManip.v1,
      cfg.ablated.v1,
      cfg.catheterAblation.v1,
      cfg.useEnded.v1,
      cfg.catheterUseEnding.v1,
      cfg.installReason.v1,
      cfg.tunneled.v1,
      cfg.installSite.v1,
      cfg.siteChanges.v1,
      cfg.antibiopr.v1,
      ...cfg.lock.install.v1,
      ...cfg.lock.disconnect.v1,
      infection.v1
    ],

    v2: [
      cfg.accessSite.v2,
      cfg.catheterFirstUse.v2,
      cfg.uses.v2,
      cfg.incidents.v2,
      cfg.unrelatedManip.v2,
      cfg.ablated.v2,
      cfg.catheterAblation.v2,
      cfg.useEnded.v2,
      cfg.catheterUseEnding.v2,
      cfg.installReason.v2,
      cfg.tunneled.v2,
      cfg.installSite.v2,
      cfg.siteChanges.v2,
      cfg.antibiopr.v2,
      ...cfg.lock.install.v2,
      ...cfg.lock.disconnect.v2,
      infection.v2
    ],

    v3: [
      cfg.accessSite.v2,
      cfg.catheterFirstUse.v2,
      cfg.uses.v2,
      cfg.incidents.v2,
      cfg.unrelatedManip.v2,
      cfg.ablated.v2,
      cfg.catheterAblation.v2,
      cfg.useEnded.v2,
      cfg.catheterUseEnding.v2,
      cfg.installReason.v2,
      cfg.tunneled.v2,
      cfg.installSite.v2,
      cfg.siteChanges.v2,
      cfg.antibiopr.v2,
      ...cfg.lock.install.v2,
      ...cfg.lock.disconnect.v2,
      infection.v3
    ],

    v4: [
      cfg.accessSite.v2,
      cfg.catheterFirstUse.v2,
      cfg.uses.v2,
      cfg.incidents.v2,
      cfg.unrelatedManip.v2,
      cfg.ablated.v2,
      cfg.catheterAblation.v2,
      cfg.useEnded.v2,
      cfg.catheterUseEnding.v2,
      cfg.installReason.v2,
      cfg.tunneled.v2,
      cfg.installSite.v2,
      cfg.siteChanges.v2,
      cfg.antibiopr.v2,
      ...cfg.lock.install.v2,
      ...cfg.lock.disconnect.v2,
      infection.v4
    ],

    v5: [
      cfg.accessSite.v2,
      cfg.catheterFirstUse.v2,
      cfg.uses.v2,
      cfg.incidents.v2,
      cfg.unrelatedManip.v2,
      cfg.ablated.v2,
      cfg.catheterAblation.v2,
      cfg.useEnded.v2,
      cfg.catheterUseEnding.v2,
      cfg.installReason.v2,
      cfg.tunneled.v2,
      cfg.installSite.v2,
      cfg.siteChanges.v2,
      cfg.antibiopr.v2,
      ...cfg.lock.install.v2,
      ...cfg.lock.disconnect.v2,
      infection.v5
    ]
  }

  function build (list) {
    return {
      field: fields.catheterArray,
      type: 'array',
      config: {
        title: `SITE D'ACCÈS N°`,
        fields: list
      }
    }
  }

  return {
    v1: build(ktFields.v1),
    v2: build(ktFields.v2),
    v3: build(ktFields.v3),
    v4: build(ktFields.v4),
    v5: build(ktFields.v5)
  }
})()

const exp = {
  '2019': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectheparine'
      }
    ],
    fields: [
      ...patientFields.v1,
      catheter.v1,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v1.dia
        }
      }
    ],
    buildNotes: function (result, sheet, surveillance) {
      return notes.build2019(result, sheet, surveillance)
    }
  },

  '2020': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v2,
      catheter.v2,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v2.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2020(result, sheet, surveillance)
    }
  },

  '2021': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v3,
      catheter.v2,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v3.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2021(result, sheet, surveillance)
    }
  },

  '2022': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v3,
      catheter.v2,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v4.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2022(result, sheet, surveillance)
    }
  },

  '2023': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v3,
      catheter.v3,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v5.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2023(result, sheet, surveillance)
    }
  },

  '2024': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v4,
      catheter.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v6.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2024(result, sheet, surveillance)
    }
  },

  '2025': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v4,
      catheter.v5,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v7.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2025(result, sheet, surveillance)
    }
  },

  '2026': {
    titles: titles,
    repeatableTitles: [
      {
        text: 'POSE DU CATHÉTER',
        type: 'subtitle',
        start: fields.installReason
      },
      {
        text: 'DÉBRANCHEMENT DU CATHÉTER',
        type: 'subtitle',
        start: 'disconnectLock'
      }
    ],

    fields: [
      ...patientFields.v4,
      catheter.v5,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v8.dia
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2026(result, sheet, surveillance)
    }
  }
}

export default exp
